import { ISmartTableFilterLabels } from "./types";

export const FILTERS_IDENTATION = 40;

export const DEFAULT_LABELS: ISmartTableFilterLabels = {
  addAndSibling: "Add AND sibling",
  addOrSibling: "Add OR sibling",
  and: "AND",
  booleanFalseValue: "False",
  booleanTrueValue: "True",
  buttonLabel: "Adv. Filter",
  cancel: "Close",
  clear: "Clear Filters",
  close: "Close",
  createAndGroup: "Create AND group",
  createOrGroup: "Create OR group",
  deleteFilter: "Delete filter",
  deleteCondition: "Delete condition",
  editName: "Edit filter name",
  filterNameAlreadyExists: "Filter name already exists",
  filterNameUnique: "Filter name must be unique",
  filterPreviewTitle: "Filter preview",
  filterSettings: "Settings",
  manageFilters: "Manage filters",
  name: "Name",
  none: "None",
  or: "OR",
  replaceFilter: "Replace filter",
  save: "Apply Filters",
  saveChange: "Save change",
  saveFilter: "Save Filter",
  selectField: "Field",
  selectOperator: "Operator",
  selectStoredFilter: "Select stored filter",
  selectValue: "Select value",
  storeFilter: "Store filter",
  storeFilterHelpText: "Save filter for future use",
  title: "Filters",
  operators: {
    StringFilterOperatorEnum: {
      EQUALS: "Equals",
      CONTAINS: "Contains",
      STARTS_WITH: "Starts with",
      ENDS_WITH: "Ends with",
    },
    NumberFilterOperatorEnum: {
      EQUALS: "Equals",
      CONTAINS: "Contains",
      GREATER_THAN: "Greater than",
      LESS_THAN: "Less than",
      GREATER_THAN_OR_EQUALS: "Greater than or equals",
      LESS_THAN_OR_EQUALS: "Less than or equals",
    },
    ListFilterOperatorEnum: {
      IN: "In",
      NOT_IN: "Not in",
    },
  },
};
